import { render, staticRenderFns } from "./PisList.vue?vue&type=template&id=72acbc2c&"
import script from "./PisList.vue?vue&type=script&lang=js&"
export * from "./PisList.vue?vue&type=script&lang=js&"
import style0 from "./PisList.vue?vue&type=style&index=0&id=72acbc2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports